import IconTextFormInput from '@/components/form/IconTextFormInput'
import { useAuthContext } from '@/context/useAuthContext'
import { useNotificationContext } from '@/context/useNotificationContext'
import httpClient from '@/helpers/httpClient'
import { yupResolver } from '@hookform/resolvers/yup'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { BsEnvelopeFill } from 'react-icons/bs'
import { FaLock } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import * as yup from 'yup'

const SignInForm = ({ onSignUpClick, onLoginSuccess }) => {
  const [loading, setLoading] = useState(false)
  const { saveSession } = useAuthContext()
  const { showNotification } = useNotificationContext()

  const loginFormSchema = yup.object({
    email: yup.string().email('Please enter a valid email').required('Please enter your email'),
    password: yup.string().required('Please enter your password'),
  })

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(loginFormSchema),
    defaultValues: {
      email: 'user@demo.com',
      password: 'password',
    },
  })

  const login = handleSubmit(async (values) => {
    setLoading(true)
    try {
      const res = await httpClient.post('/auth/login', values)
      if (res.data.token) {
        saveSession({ ...res.data, token: res.data.token })
        showNotification({
          message: 'Successfully logged in.',
          variant: 'success',
        })
        onLoginSuccess()
      }
    } catch (e) {
      if (e.response?.data?.error) {
        showNotification({
          message: e.response.data.error,
          variant: 'danger',
        })
      }
    } finally {
      setLoading(false)
    }
  })

  return (
    <form onSubmit={login}>
      <div className="mb-4">
        <IconTextFormInput control={control} icon={BsEnvelopeFill} placeholder="E-mail" label="Email address *" name="email" />
      </div>
      <div className="mb-4">
        <IconTextFormInput type="password" control={control} icon={FaLock} placeholder="password" label="Password *" name="password" />
      </div>
      <div className="mb-4 d-flex justify-content-between">
        <div className="form-check">
          <input type="checkbox" className="form-check-input" id="rememberMe" />
          <label className="form-check-label" htmlFor="rememberMe">
            Remember me
          </label>
        </div>
        <div className="text-primary-hover">
          <Link to="#" className="text-secondary">
            <u>Forgot password?</u>
          </Link>
        </div>
      </div>
      <div className="align-items-center mt-0">
        <div className="d-grid">
          <button className="btn btn-primary mb-0" disabled={loading} type="submit">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </div>
      <div className="mt-4 text-center">
        <span>
          Don't have an account?{' '}
          <Link to="#" onClick={onSignUpClick}>
            Signup here
          </Link>
        </span>
      </div>
    </form>
  )
}

export default SignInForm
